
// File: src/components/sections/CTASection/CTASection.tsx
import React from "react";
import { DefaultSection, DefaultSectionProps } from "./DefaultSection";
import { Button } from "../../general/Button";
import { Flex } from "../wrappers";

interface CTASectionProps extends DefaultSectionProps {
  title?: string;
  subtitle?: string;
  primaryLabel?: string;
  secondaryLabel?: string;
  onPrimary?: () => void;
  onSecondary?: () => void;
 
}

export const CTASection: React.FC<CTASectionProps> = ({
  title = "Ready to Learn?",
  subtitle = "Join the community today",
  primaryLabel = "Sign Up",
  secondaryLabel = "Browse Lessons",
  onPrimary,
  onSecondary,
  backgroundMedia,
  actions,
  contentOverlay
}) => {
  return (
    <DefaultSection
      sectionId="cta"
      title={title}
      subtitle={subtitle}
      backgroundMedia={backgroundMedia?.mediaName && backgroundMedia?.mediaBaseUrl ? {
        type: "video",
        useMediaLoader: true,
        mediaName: backgroundMedia.mediaName,
        mediaBaseUrl: backgroundMedia.mediaBaseUrl,
      } : backgroundMedia}
      alignment="center"
      contentOverlay={contentOverlay || {
        color: "rgba(255,255,255,0.125)",
        blur: true,
      }}
      fullHeight
      animateOnScroll
      snap
       actions={
              actions === undefined ? (
                <Flex gap="md" wrap="wrap" justify="center">
                  <Button variant="primary" size="large" onClick={onPrimary}>
                    Get Started
                  </Button>
                  <Button variant="secondary" size="large" onClick={onSecondary}>
                    Explore
                  </Button>
                </Flex>
              ) : actions || undefined
            }
    />
  );
};
